import Link from "next/link"
import { useTranslations } from "next-intl"

export const Logo = ({ withinLink }: { withinLink?: boolean }) => {
  const taria = useTranslations("AriaLabel")

  if (withinLink)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        zoomAndPan="magnify"
        viewBox="0 0 211.5 56.999997"
        height="40"
        preserveAspectRatio="xMidYMid meet"
        version="1.0"
      >
        <defs>
          <g />
          <clipPath id="e387b1a02d">
            <path d="M 13 24 L 64.347656 24 L 64.347656 33 L 13 33 Z M 13 24 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="ef64e1516f">
            <path d="M 22 4 L 64.347656 4 L 64.347656 13 L 22 13 Z M 22 4 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="82f5261302">
            <path d="M 44 14 L 64.347656 14 L 64.347656 23 L 44 23 Z M 44 14 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="acdea990bb">
            <path d="M 24 34 L 64.347656 34 L 64.347656 43 L 24 43 Z M 24 34 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="8a19060377">
            <path d="M 28 43 L 64.347656 43 L 64.347656 53 L 28 53 Z M 28 43 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="cf0eb0bbba">
            <path
              d="M 63 0.0664062 L 66 0.0664062 L 66 56.933594 L 63 56.933594 Z M 63 0.0664062 "
              clipRule="nonzero"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#e387b1a02d)">
          <path
            fill="#0091ff"
            d="M 86.5625 24.496094 L 45.144531 24.496094 L 43.375 27.550781 L 39.28125 27.550781 L 37.511719 24.496094 C 35.984375 24.496094 16.878906 24.496094 15.351562 24.496094 L 13.066406 28.457031 L 15.351562 32.417969 C 16.878906 32.417969 35.984375 32.417969 37.511719 32.417969 L 39.28125 29.359375 L 43.375 29.359375 L 45.144531 32.417969 L 86.5625 32.417969 C 87.015625 29.800781 87.015625 27.121094 86.5625 24.496094 Z M 86.5625 24.496094 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#ef64e1516f)">
          <path
            fill="#0091ff"
            d="M 29.699219 12.941406 L 31.464844 9.882812 L 35.5625 9.882812 L 37.332031 12.941406 L 80.996094 12.941406 C 72.789062 3.6875 63.585938 5.007812 52.484375 5.007812 L 37.332031 5.007812 L 35.5625 8.066406 L 31.464844 8.066406 L 29.699219 5.007812 L 25.121094 5.007812 L 22.835938 8.96875 L 25.121094 12.933594 L 29.699219 12.933594 Z M 29.699219 12.941406 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#82f5261302)">
          <path
            fill="#0091ff"
            d="M 57.050781 17.8125 L 52.957031 17.8125 L 51.1875 14.753906 L 46.613281 14.753906 L 44.324219 18.71875 L 46.613281 22.679688 L 51.1875 22.679688 L 52.957031 19.621094 L 57.050781 19.621094 L 58.820312 22.679688 L 86.175781 22.679688 C 85.4375 19.785156 84.15625 17.105469 82.449219 14.746094 L 58.820312 14.746094 Z M 57.050781 17.8125 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <path
          fill="#0091ff"
          d="M 2.289062 24.496094 L 0 28.457031 L 2.289062 32.425781 L 6.871094 32.425781 L 9.15625 28.457031 L 6.871094 24.496094 Z M 2.289062 24.496094 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#0091ff"
          d="M 31.261719 18.71875 L 33.550781 22.679688 L 38.132812 22.679688 L 40.417969 18.71875 L 38.132812 14.753906 L 33.550781 14.753906 Z M 31.261719 18.71875 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#0091ff"
          d="M 17.921875 43.972656 L 15.628906 47.941406 L 17.921875 51.90625 L 22.496094 51.90625 L 24.785156 47.941406 L 22.496094 43.972656 Z M 17.921875 43.972656 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <g clipPath="url(#acdea990bb)">
          <path
            fill="#0091ff"
            d="M 37.511719 37.292969 L 33.414062 37.292969 L 31.648438 34.234375 L 27.070312 34.234375 L 24.785156 38.195312 L 27.070312 42.15625 L 31.648438 42.15625 L 33.414062 39.097656 L 37.511719 39.097656 L 39.28125 42.15625 L 82.441406 42.15625 C 84.148438 39.800781 85.429688 37.117188 86.167969 34.226562 C 71.835938 34.226562 53.601562 34.226562 39.273438 34.226562 Z M 37.511719 37.292969 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#8a19060377)">
          <path
            fill="#0091ff"
            d="M 49.238281 47.039062 L 45.144531 47.039062 L 43.375 43.980469 C 39.25 43.980469 35.113281 43.980469 30.980469 43.980469 L 28.691406 47.941406 L 30.980469 51.90625 C 35.113281 51.90625 39.238281 51.90625 43.375 51.90625 L 45.144531 48.847656 L 49.238281 48.847656 L 51.007812 51.90625 C 62.726562 51.90625 72.578125 53.46875 80.996094 43.972656 L 51.007812 43.972656 Z M 49.238281 47.039062 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#cf0eb0bbba)">
          <path
            strokeLinecap="round"
            transform="matrix(0, 0.748231, -0.748231, 0, 65.717387, 0.399386)"
            fill="none"
            strokeLinejoin="miter"
            d="M 1.502278 1.501724 L 73.829113 1.501724 "
            stroke="#0091ff"
            strokeWidth="3"
            strokeOpacity="1"
            strokeMiterlimit="4"
          />
        </g>
      </svg>
    )

  return (
    <Link href={"/"} aria-label={taria("footerLogoAria")} rel="noreferrer noopener">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        zoomAndPan="magnify"
        viewBox="0 0 211.5 56.999997"
        height="40"
        preserveAspectRatio="xMidYMid meet"
        version="1.0"
      >
        <defs>
          <g />
          <clipPath id="e387b1a02d">
            <path d="M 13 24 L 64.347656 24 L 64.347656 33 L 13 33 Z M 13 24 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="ef64e1516f">
            <path d="M 22 4 L 64.347656 4 L 64.347656 13 L 22 13 Z M 22 4 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="82f5261302">
            <path d="M 44 14 L 64.347656 14 L 64.347656 23 L 44 23 Z M 44 14 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="acdea990bb">
            <path d="M 24 34 L 64.347656 34 L 64.347656 43 L 24 43 Z M 24 34 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="8a19060377">
            <path d="M 28 43 L 64.347656 43 L 64.347656 53 L 28 53 Z M 28 43 " clipRule="nonzero" />
          </clipPath>
          <clipPath id="cf0eb0bbba">
            <path
              d="M 63 0.0664062 L 66 0.0664062 L 66 56.933594 L 63 56.933594 Z M 63 0.0664062 "
              clipRule="nonzero"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#e387b1a02d)">
          <path
            fill="#0091ff"
            d="M 86.5625 24.496094 L 45.144531 24.496094 L 43.375 27.550781 L 39.28125 27.550781 L 37.511719 24.496094 C 35.984375 24.496094 16.878906 24.496094 15.351562 24.496094 L 13.066406 28.457031 L 15.351562 32.417969 C 16.878906 32.417969 35.984375 32.417969 37.511719 32.417969 L 39.28125 29.359375 L 43.375 29.359375 L 45.144531 32.417969 L 86.5625 32.417969 C 87.015625 29.800781 87.015625 27.121094 86.5625 24.496094 Z M 86.5625 24.496094 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#ef64e1516f)">
          <path
            fill="#0091ff"
            d="M 29.699219 12.941406 L 31.464844 9.882812 L 35.5625 9.882812 L 37.332031 12.941406 L 80.996094 12.941406 C 72.789062 3.6875 63.585938 5.007812 52.484375 5.007812 L 37.332031 5.007812 L 35.5625 8.066406 L 31.464844 8.066406 L 29.699219 5.007812 L 25.121094 5.007812 L 22.835938 8.96875 L 25.121094 12.933594 L 29.699219 12.933594 Z M 29.699219 12.941406 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#82f5261302)">
          <path
            fill="#0091ff"
            d="M 57.050781 17.8125 L 52.957031 17.8125 L 51.1875 14.753906 L 46.613281 14.753906 L 44.324219 18.71875 L 46.613281 22.679688 L 51.1875 22.679688 L 52.957031 19.621094 L 57.050781 19.621094 L 58.820312 22.679688 L 86.175781 22.679688 C 85.4375 19.785156 84.15625 17.105469 82.449219 14.746094 L 58.820312 14.746094 Z M 57.050781 17.8125 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <path
          fill="#0091ff"
          d="M 2.289062 24.496094 L 0 28.457031 L 2.289062 32.425781 L 6.871094 32.425781 L 9.15625 28.457031 L 6.871094 24.496094 Z M 2.289062 24.496094 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#0091ff"
          d="M 31.261719 18.71875 L 33.550781 22.679688 L 38.132812 22.679688 L 40.417969 18.71875 L 38.132812 14.753906 L 33.550781 14.753906 Z M 31.261719 18.71875 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <path
          fill="#0091ff"
          d="M 17.921875 43.972656 L 15.628906 47.941406 L 17.921875 51.90625 L 22.496094 51.90625 L 24.785156 47.941406 L 22.496094 43.972656 Z M 17.921875 43.972656 "
          fillOpacity="1"
          fillRule="nonzero"
        />
        <g clipPath="url(#acdea990bb)">
          <path
            fill="#0091ff"
            d="M 37.511719 37.292969 L 33.414062 37.292969 L 31.648438 34.234375 L 27.070312 34.234375 L 24.785156 38.195312 L 27.070312 42.15625 L 31.648438 42.15625 L 33.414062 39.097656 L 37.511719 39.097656 L 39.28125 42.15625 L 82.441406 42.15625 C 84.148438 39.800781 85.429688 37.117188 86.167969 34.226562 C 71.835938 34.226562 53.601562 34.226562 39.273438 34.226562 Z M 37.511719 37.292969 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#8a19060377)">
          <path
            fill="#0091ff"
            d="M 49.238281 47.039062 L 45.144531 47.039062 L 43.375 43.980469 C 39.25 43.980469 35.113281 43.980469 30.980469 43.980469 L 28.691406 47.941406 L 30.980469 51.90625 C 35.113281 51.90625 39.238281 51.90625 43.375 51.90625 L 45.144531 48.847656 L 49.238281 48.847656 L 51.007812 51.90625 C 62.726562 51.90625 72.578125 53.46875 80.996094 43.972656 L 51.007812 43.972656 Z M 49.238281 47.039062 "
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
        <g clipPath="url(#cf0eb0bbba)">
          <path
            strokeLinecap="round"
            transform="matrix(0, 0.748231, -0.748231, 0, 65.717387, 0.399386)"
            fill="none"
            strokeLinejoin="miter"
            d="M 1.502278 1.501724 L 73.829113 1.501724 "
            stroke="#0091ff"
            strokeWidth="3"
            strokeOpacity="1"
            strokeMiterlimit="4"
          />
        </g>
      </svg>
    </Link>
  )
}
